<div #contentRevised>
  <div class="row" *ngFor="let section of sections">
    <div class="col-12">
      <div class="card cv-card__main shadow-sm">
        <div class="card-header" *ngIf="this.schemaName.indexOf('InspectionReport') === -1">{{section.title}}</div>
        <div class="card-body">
          <div class="row card-body-container" *ngFor="let row of section.items">

            <div *ngFor="let field of row" [ngClass]="field.cssClass" class="field-container">
              <ng-container [ngSwitch]="field.type">

                <ng-container *ngSwitchCase="'table'">
                  <ng-template *ngTemplateOutlet="tableTpl; context: {$implicit: field}"></ng-template>
                </ng-container>

                <ng-container *ngSwitchCase="'static-table'">
                  <ng-template *ngTemplateOutlet="staticTableTpl; context: {$implicit: field}"></ng-template>
                </ng-container>

                <ng-container *ngSwitchCase="'multi-rows'">
                  <div class="cv__review-fields_multi-rows" >
                    <div class="row" *ngFor="let row of field.fields">
                      <ng-container *ngFor="let innerField of row">
                        <div [ngClass]="innerField.cssClass || 'col-md-12'" [ngSwitch]="innerField.type">
                          <div *ngSwitchCase="'table'">
                            <ng-template *ngTemplateOutlet="tableTpl; context: {$implicit: innerField}"></ng-template>
                          </div>

                          <div *ngSwitchCase="'static-table'">
                            <ng-template *ngTemplateOutlet="staticTableTpl; context: {$implicit: innerField}">
                            </ng-template>
                          </div>

                          <div *ngSwitchDefault>
                            <ng-template *ngTemplateOutlet="fieldTpl; context: {$implicit: innerField}"></ng-template>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'range'">
                  <div class="cv__review-fields_range" >
                    <h6 *ngIf="field.options?.label">{{field.options?.label || ''}}</h6>
                    <div *ngFor="let innerField of field.options.fields; let i = index;" class="d-inline-block">
                      <ng-template *ngTemplateOutlet="fieldTpl; context: {$implicit: innerField}"></ng-template>
                      <div class="range-connector">
                        <p>
                          <span class="px-1" *ngIf="i===0">To</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'composite-text'">
                  <div>
                    <p>
                      <span *ngFor="let part of field.options.text.split('{*}'); let i = index;">
                        {{part}}
                        <span class="font-weight-bold" *ngIf="i < (field.options.text.split('{*}').length - 1)">
                          <ng-template *ngTemplateOutlet="fieldTpl; context: {$implicit: field.options.fields[i]}">
                          </ng-template>
                        </span>
                      </span>
                    </p>
                  </div>
                </ng-container>

                <ng-container *ngSwitchDefault>
                  <ng-template *ngTemplateOutlet="fieldTpl; context: {$implicit: field}"></ng-template>
                </ng-container>

              </ng-container>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

<ng-template #fieldTpl let-field>
  <cv-review-fields class="cv_col" #fields [options]="field.options | replaceIndex:index"></cv-review-fields>
</ng-template>

<ng-template #tableTpl let-field>
  <cv-review-tables #tables [field]="field"></cv-review-tables>
</ng-template>

<ng-template #staticTableTpl let-field>
  <cv-review-static-tables #tables [field]="field"></cv-review-static-tables>
</ng-template>
